var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 87.2 93.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#c5a07d;}.cls-2{fill:#dcb998;}.cls-3{fill:#f2dac5;}.cls-4,.cls-6,.cls-7,.cls-8{fill:none;stroke-miterlimit:10;}.cls-4{stroke:#dcb998;}.cls-5{fill:#ded6ce;}.cls-6{stroke:#a3866a;}.cls-7{stroke:#f2dac5;}.cls-8{stroke:#fdebdd;}"), /*#__PURE__*/React.createElement("symbol", {
    id: "Box_01a",
    "data-name": "Box_01a",
    viewBox: "0 0 87.2 93.25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0.25 15.67 40.15 38.7 40.15 92.7 0.25 69.67 0.25 15.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "86.7 23.58 40.15 38.7 40.15 92.7 86.7 77.58 86.7 23.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0.25 15.67 40.15 38.7 86.7 23.58 46.8 0.54 0.25 15.67"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 23.49,
    y1: 8.12,
    x2: 63.39,
    y2: 31.15
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "20.2 33.19 33.5 40.87 33.5 52.87 20.2 45.19 20.2 33.19"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 40.15,
    y1: 38.7,
    x2: 40.15,
    y2: 92.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "86.7 77.58 40.15 92.7 0.25 69.67"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 86.7,
    y1: 23.58,
    x2: 86.7,
    y2: 77.58
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "0.25 15.67 46.8 0.54 86.7 23.58"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fyldning_Inspektion",
    "data-name": "Fyldning & Inspektion"
  }, /*#__PURE__*/React.createElement("use", {
    width: 87.2,
    height: 93.25,
    xlinkHref: "#Box_01a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxClosed);
export default __webpack_public_path__ + "static/media/box-closed.c9a30c32a1fb333dc3eb7fc131b9d7f2.svg";
export { ForwardRef as ReactComponent };